<template>
    <notice>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :searchable="true" :fields="fields" :items="notices" :action="{'text':'add Notice','url':route('notice.create')}" :searchlink="route('notice.branch.search')" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Notice')" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Notice')">
                <template #status="data">
                    {{data.item.status?'Active':'Inactive'}}
                </template>
                <template #due_date="data">
                    {{convertDate(data.item.due_date)}}
                </template>
                <template #created_at="data">
                    {{convertDate(data.item.created_at)}}
                </template>
                <template #action="data">
                    <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Notice')" :href="route('notice.edit',data.item.id)" >Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </notice>
</template>

<script>
    import Notice from '@/Pages/Notice/Notice'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Notice,
            BreezeTable,
            ButtonLink
        },
        props:['notices'],
        data(){
            return{
                fields:[{'key':'title','label':'Title'},{'key':'due_date','label':'Due Date'},{'key':'status','label':'Status'},{'key':'created_at','label':'Created'},{'key':'action','label':'Action'}]
            }
        }
    }
</script>
